import { handleExternalLink } from '@/utils/link-props';
import { IconArrowRight, Link, LinkProps } from '@cmpsr/components';

export default function SeeMoreDetailsLink(props: LinkProps) {
  return (
    <Link variant="link-primary" trailingIcon={<IconArrowRight />} size="m" {...handleExternalLink(props)}>
      See more details
    </Link>
  );
}
